import { Box, Stack } from "@mui/material";
import React from "react";
import SiteListRow from "./Row";

function SiteListTable({ data, onClick, onDelete }) {
  return (
    <Stack spacing={2}>
      {/* for each data use a SiteListRow */}
      {data.map((row, index) => {
        return (
          <SiteListRow
            key={index}
            data={row}
            onDelete={onDelete}
            onClick={onClick}
          />
        );
      })}
    </Stack>
  );
}

export default SiteListTable;
